import { rotateAnimation } from '@accredible-frontend-v2/animations';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'a[accredible-link], button[accredible-link]',
  templateUrl: './link.component.html',
  styleUrls: ['link.component.scss'],
  animations: [rotateAnimation],
  // ViewEncapsulation.None in order to be able to style accredible-icon without using ::ng-deep
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleLinkComponent {
  size = input<'small' | 'normal'>('normal');
  color = input<'light' | 'primary' | 'natural'>('primary');
  icon = input('external');
  iconPosition = input<'right' | 'left'>('right');
  rotateIcon = input(false);
  invertIconRtl = input(false);
  disabled = input(false);

  @HostBinding('class')
  get classes(): string {
    return `${this.size()} ${this.color()}`;
  }

  @HostBinding('attr.tabindex')
  get tabIndex(): number {
    return this.disabled() ? -1 : 0;
  }

  @HostBinding('attr.aria-disabled')
  get ariaDisabled(): string | null {
    return this.disabled() ? 'true' : null;
  }
}
